import api from './AxiosInstance';
import printJS from "print-js";
import { api_URL } from "./Constantes";
export class TraitementService {
   
  deleteLines = async (payload) => {
  try {
    const response = await api.post(`Facture/delete`,payload, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};
  deleteLine= async (numdoc) => {
    try {
      const response = await api.delete(`/Document/delete/${numdoc}/IPM/dev1`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
 
  getPlanComptafourn = async () => {
    try {
      const response = await api.get(`/PlanCompta/FournDiv/list`, {
       
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      throw error;
    }
  };

  getDetailsByNumDoc = async (numdoc) => {
    try {
      const response = await api.get(`/Document/GetDetails/${numdoc}`, {
       
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      throw error;
    }
  };
 //
  exportEtatsMensuels = async (selectedYearExercises, selectedMonth, codeadht) => {
    try {
      const response = await api.get(`/Print/EtatsMensuels/Excel/${selectedYearExercises}/${selectedMonth}/${codeadht}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${codeadht}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erreur lors de l\'exportation :', error);
      throw error;
    }
  };
  addValidCompta = async (payload) => {
    try {
      const response = await api.post(`/Compta/ValidPreviewCompta/IF`,payload, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  }; 
  addValidCompta1 = async (payload) => {
    try {
      const response = await api.post(`/Compta/ValidPreviewCompta/FG`,payload, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  }; 

  addPreviewCompta = async (payload) => {
    try {
      const response = await api.post(`/Compta/PreviewCompta/IF`,payload, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  }; 

  addPreviewCompta1 = async (payload) => {
    try {
      const response = await api.post(`/Compta/PreviewCompta/FG`,payload, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  }; 

addAnnulationCompta = async (payload) => {
  try {
    const response = await api.post(`/Compta/ValidPreviewComptaFactureAnnuler/Compta`, payload,{
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};
putAnnulationCompta = async (payload) => {
  try {
    const response = await api.put(`/Facture/updateEtapeFacture/NN`,payload, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};

  getPreviewCancelCompta = async (numenreg) => {
    try {
      const response = await api.get(`/Facture/PreviewCanceledFactureCompta?numFact=${numenreg}`, {
       
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      throw error;
    }
  };

clôtureMensuel = async () => {
  try {
    const response = await api.put(`/InfosGen/openPeriodeCompta/param3`, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};

reculClôtureMensuel = async () => {
  try {
    const response = await api.put(`/InfosGen/reculPeriodeCompta/param3`, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};

reculClôtureMensuel1 = async (selectedMonthCompta, payload) => {
  try {
    const response = await api.put(`/Facture/updateMoisFacture/${selectedMonthCompta}`, payload,
      {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
}; 

closeMensuel = async () => {
  try {
    const response = await api.put(`/InfosGen/closePeriodeCompta/param3`, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};

newExo = async (payload) => {
  try {
    const response = await api.post(`/Compta/ValidPreviewCompta/RAN`,payload, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};

closeOpenMensuel = async (payload) => {
  try {
    const response = await api.put(`/InfosGen/openPeriodeCompta/param3`,payload, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};



AddFacture = async (docData) => {
  try {
      // Récupérer le user_id depuis le localStorage
      const userId = localStorage.getItem('login');

      const response = await api.post(`/Facture/add`, docData, 
      {
          headers: {
              'user_id': userId, // Utiliser le user_id dynamique
          } 
      });
    
      // Ajoutez une console.log pour afficher la réponse du serveur
      console.log('Réponse du serveur après l\'ajout de la facture :', response.data);

      return response.data;
  } catch (error) {
      console.error('Erreur lors de l\'ajout de la facture :', error);
      // Assurez-vous que la promesse est rejetée pour propager l'erreur
      throw error;
  }
};


  UpdateFacture = async (docData) => {
    try {
      const response = await api.post(`/Facture/Divers/update`, docData , 
      {
        
        }) 
      
      // Ajoutez une console.log pour afficher la réponse du serveur
      console.log('Réponse du serveur après l\'ajout de la facture :', response.data);

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de la facture :', error);
      // Assurez-vous que la promesse est rejetée pour propager l'erreur
      throw error;
    }
  };

  EditFacture = async (numenreg, payload) => {
    try {
      const userId = localStorage.getItem('login');
      const response = await api.put(`/Facture/${numenreg}`, payload,  {
        headers: {
          'user_id': userId, // Utiliser le user_id dynamique
      }  
       });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour des données :', error);
    }
  };
  
      deleteFacture = async (numenreg) => {
        try {
          const response = await api.delete(`/Facture/${numenreg}`);
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
        
        }
      };

      getParamComptable = async () => {
        try {
          const response = await api.get(`/InfosGen/DateCompta/param3`, {
         
          });
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
          // Gérer l'erreur ici si nécessaire
          throw error; 
        }
      };
        ImportFile = async (numenreg, formData) => {
          try {
            const response = await api.post(`/Facture/uploadFile/${numenreg}?facture`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la récupération des données :', error);
            throw error;
          }
        };
        ImportBonFile = async (formData) => {
          try {
           
            const response = await api.post(`/Document/docsImport`, formData, {
                /* headers: {
                  'Content-Type': 'multipart/form-data',
                },  */
              });
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la récupération des données :', error);
            throw error;
          }
        };

        errorBon = async () => {
          try {
            const response = await api.get(`/Document/Bons/Export`, {
              responseType: 'blob', // Indique que la réponse est un fichier binaire
            });
            
            // Vérifiez que la réponse est un fichier
            if (response.data) {
              const blob = new Blob([response.data], {
                type: "application/vnd.ms-excel", // Type correct pour un fichier .xls
              });
      
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "bons_erronés.xls"); // Nom du fichier à télécharger
              document.body.appendChild(link);
              link.click();
              link.remove();
            } else {
              console.error("La réponse ne contient pas de données.");
            }
            
            return response.data;
          } catch (error) {
            console.error("Erreur lors de la récupération des données :", error);
            throw error;
          }
        };
        errorActes = async () => {
          try {
            const response = await api.get(`/Document/Actes/Export`, {
              responseType: 'blob', // Indique que la réponse est un fichier binaire
            });
            
            // Vérifiez que la réponse est un fichier
            if (response.data) {
              const blob = new Blob([response.data], {
                type: "application/vnd.ms-excel", // Type correct pour un fichier .xls
              });
      
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "actes_erronés.xls"); // Nom du fichier à télécharger
              document.body.appendChild(link);
              link.click();
              link.remove();
            } else {
              console.error("La réponse ne contient pas de données.");
            }
            
            return response.data;
          } catch (error) {
            console.error("Erreur lors de la récupération des données :", error);
            throw error;
          }
        };
    
      errorBonsTraites = async () => {
        try {
          const response = await api.get(`/Document/BonsTraites/Export`, {
            responseType: 'blob', // Indique que la réponse est un fichier binaire
          });
          
          // Vérifiez que la réponse est un fichier
          if (response.data) {
            const blob = new Blob([response.data], {
              type: "application/vnd.ms-excel", // Type correct pour un fichier .xls
            });
    
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Errors_BonsTraites.xls"); // Nom du fichier à télécharger
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            console.error("La réponse ne contient pas de données.");
          }
          
          return response.data;
        } catch (error) {
          console.error("Erreur lors de la récupération des données :", error);
          throw error;
        }
      };
        ///Document/Bons/Export
        
        RegereDonnee= async ( updatedPrestation) => {
          try {
           
      
            const response = await api.put(`/Document/Regenerer`, updatedPrestation)
      
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la mise à jour de prestation :', error);
            throw error;
          }
        };

        RegenereFactureSoin= async (numenreg,  updatedPrestation) => {
          try {
           
      
            const response = await api.put(`/Facture/regenererFactureSoins/${numenreg}`, updatedPrestation)
      
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la mise à jour de prestation :', error);
            throw error;
          }
        };
        RegenereFactureDiv= async (numenreg,  updatedPrestation) => {
          try {
           
      
            const response = await api.put(`Facture/regenererFactureDiv/${numenreg}`, updatedPrestation)
      
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la mise à jour de prestation :', error);
            throw error;
          }
        };
      
      updateListTraitementFact= async (fournisseurId, payload) => {
        try {
          const response = await api.put(`/Facture/${fournisseurId}`,payload, {
         
          });
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
          // Gérer l'erreur ici si nécessaire
          throw error; 
        }
      };

      getDetailsActes = async (selectedYear, selectedMonth) => {
        try {
          const response = await api.get(`/Facture/getImputationsByYear/${selectedYear}/${selectedMonth}`, {});
          return response.data;
        } catch (error) {
          console.error("Erreur lors de la récupération des données :", error);
          // Gérer l'erreur ici si nécessaire
          throw error;
        }
      };

        getOneListTraitementFact = async (fournisseurId) => {
          try {
            const response = await api.get(`/Document/ByFacture/list/IPM/${fournisseurId}`, {
           
            });
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la récupération des données :', error);
            // Gérer l'erreur ici si nécessaire
            throw error; 
          }
        };
        getOneListTraitementFourn = async (numfourn) => {
          try {
            const response = await api.get(`/Document/ByFourn/list/IPM/${numfourn}`, {
           
            });
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la récupération des données :', error);
            // Gérer l'erreur ici si nécessaire
            throw error; 
          }
        };
        getExercices = async () => {
          try {
            const response = await api.get(`/Compta/Exercices`, {
           
            });
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la récupération des données :', error);
            // Gérer l'erreur ici si nécessaire
            throw error; 
          }
        };
 
getAllFactureSoins = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/list/A/S?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  
  getReçueFactureSoins = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/list/R/S?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  getRejetFactureSoins = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/list/J/S?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  getEncoursFactureSoins = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/list/S/S?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  getTraiteFactureSoins = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/list/T/S?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  getComptFactureSoins = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/list/C/S?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  getPayFactureSoins = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/list/P/S?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  
  

  getAllDivers = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/Divers/list/A/D?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  getReçueDivers = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/Divers/list/R/D?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  getTraiteDivers = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/Divers/list/T/D?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  getComptaDivers = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/Divers/list/C/D?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  getPayeDivers = async ( years) => {
    try {
      const response = await api.get(
        `/Facture/Divers/list/P/D?exercice=${years}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
//updatedPrintedFacture
updatedPayloadPrint = async ( payload) => {
  try {
    const response = await api.put(`/Facture/updatedPrintedFacture`, payload,  {
    
     });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour des données :', error);
  }
};

previewImputPayload = async ( payload) => {
  try {
    const response = await api.get(`/Facture/PreviewImputationsByFact`, payload,  {
    
     });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour des données :', error);
  }
};

UpdatePrinted = async (numenreg, payload) => {
  try {
    const response = await api.put(`/Facture/Rejet/${numenreg}`, payload,{
     });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour des données :', error);
  }
};

printImputationService = (selectedYearExercises, selectedMonth, codeadht, docName) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
  const url = `${api_URL}Print/EtatsMensuels/${selectedYearExercises}/${selectedMonth}/${codeadht}?docName=${docName}`;

  fetch(url, {
    method: 'GET',  
    headers: {
      'user_id': userId,
      'username': username,  
    },
  })
  .then(response => response.blob())
  .then(blob => {
    const file = new Blob([blob], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    
    printJS(fileURL);
  })
  .catch(error => console.error('Erreur lors de la récupération du PDF', error));
};
//docName=List_Factures_Compta
printListFactureService = (selectedYearExercises, selectedMonth, selectedType, docName) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
  const url = `${api_URL}Print/EtatsMensuels/Factures/${selectedYearExercises}/${selectedMonth}/${selectedType}?docName=${docName}`;

  fetch(url, {
    method: 'GET',  
    headers: {
      'user_id': userId,
      'username': username,  
    },
  })
  .then(response => response.blob())
  .then(blob => {
    const file = new Blob([blob], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    
    printJS(fileURL);
  })
  .catch(error => console.error('Erreur lors de la récupération du PDF', error));
};

printVentilationService = (docName, selectedYearExercises, selectedMonth) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
  const url = `${api_URL}/Print/EtatsMensuels/${selectedYearExercises}/${selectedMonth}/S01?docName=${docName}`;

  fetch(url, {
    method: 'GET',  
    headers: {
      'user_id': userId,
      'username': username,  
    },
  })
  .then(response => response.blob())
  .then(blob => {
    const file = new Blob([blob], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    printJS(fileURL);
  })
  .catch(error => console.error('Erreur lors de la récupération du PDF', error));
};

printFactureFolioService = (docName, selectedYearExercises, selectedMonth) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
  const url = `${api_URL}/Print/EtatsMensuels/${selectedYearExercises}/${selectedMonth}/S01?docName=${docName}`;

  fetch(url, {
    method: 'GET',  
    headers: {
      'user_id': userId,
      'username': username,  
    },
  })
  .then(response => response.blob())
  .then(blob => {
    const file = new Blob([blob], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    printJS(fileURL);
  })
  .catch(error => console.error('Erreur lors de la récupération du PDF', error));
};

printFactureGlobalService = (docName, selectedYearExercises, selectedMonth) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
  const url = `${api_URL}/Print/EtatsMensuels/${selectedYearExercises}/${selectedMonth}/S01?docName=${docName}`;

  fetch(url, {
    method: 'GET',  
    headers: {
      'user_id': userId,
      'username': username,  
    },
  })
  .then(response => response.blob())
  .then(blob => {
    const file = new Blob([blob], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    printJS(fileURL);
  })
  .catch(error => console.error('Erreur lors de la récupération du PDF', error));
};

printRejetService = (docName, numenreg) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
  const url = `${api_URL}/Print/EtatsMensuels/Rejet/${numenreg}?docName=${docName}`;

  fetch(url, {
    method: 'GET',  
    headers: {
      'user_id': userId,
      'username': username,  
    },
  })
  .then(response => response.blob())
  .then(blob => {
    const file = new Blob([blob], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    printJS(fileURL);
  })
  .catch(error => console.error('Erreur lors de la récupération du PDF', error));
};

}


